import App from './src/App.svelte';

const app = document.querySelectorAll('[id^="asx-announcement-tabs-"]').forEach(el => {
  const includedTypes = el.getAttribute('data-announcement-types');
  const dataJsonPath = el.getAttribute('data-json-path');
  new App({
    target: el,
    props: {
      instanceId: el.id, // Pass the unique ID as a prop if needed
      dataJsonPath,
      includedTypes: includedTypes ? includedTypes.split(',').map(type => type.replace(/^ +/, '').trim()) : [] // Parse the value and pass as an array
    }
  });
});

export default app;